<form ngForm name="deleteAccountForm">
  <h3 class="pb-3">{{ 'delete your profile title' | translate }}</h3>
  <p class="pb-3">{{ 'delete your profile description' | translate }}</p>
  <div class="row">
    <div class="col-12 col-md-6">
      <app-input [title]='"Current password" | translate' [type]='"password"' [name]="'password'" [(ngModel)]="currentPassword"
        required></app-input>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <app-checkbox [title]="'delete your profile agree' | translate" [name]="'agree'" [(ngModel)]="agree" [textInTop]="true" required></app-checkbox>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-5">
      <app-button [title]="'Abort' | translate" (click)="onAbort()" [isLeftStyle]="true"></app-button>
    </div>
    <div class="col-12 col-md-7">
      <app-button [title]="'delete account button' | translate" (clickEvent)="onDelete()" [disabled]="!isFormValid"></app-button>
    </div>
  </div>
</form>
